import * as _ from 'lodash';
import * as Types from '../model/types';
import * as Graph from '../graph';

export const opArray = Graph.makeOp({
  hidden: true,
  name: 'list',
  // This takes a variable number of arguments, but we only specify one...
  // TODO: This will break the graph view. Figure out a way to specify this.
  // Using invalid type so these opArray doesn't show up in auto-suggest for now.
  argTypes: {manyX: 'invalid'},
  description: `Creates a ${Graph.docType(
    'list'
  )} from a variable number of arguments`,
  argDescriptions: {
    manyX: `The values to add to the ${Graph.docType(
      'list'
    )}: Note: in Weave, the arguments are {[index:number]: value}`,
  },
  returnValueDescription: `The ${Graph.docType('list')}`,
  returnType: inputs => {
    const argValues = Object.values(inputs);
    // I added the av.type !== null to allow for null types in the array
    // if (
    //   argValues
    //     .slice(1)
    //     .some(av => av.type !== null && !_.isEqual(av.type, argValues[0].type))
    // ) {
    //   throw new Error('array member types must be homogenous');
    // }
    return Types.listWithLength(
      argValues.length,
      argValues.length > 0
        ? Types.union(argValues.map(av => av.type))
        : 'invalid'
    );
  },
  resolver: inputs => {
    // Inputs are all arguments
    return Object.values(inputs);
  },
});

export const opDict = Graph.makeOp({
  hidden: true,
  name: 'dict',
  // This takes a variable number of arguments, but we only specify one...
  // TODO: This will break the graph view. Figure out a way to specify this.
  // Using invalid type so these opArray doesn't show up in auto-suggest for now.
  argTypes: {manyX: 'invalid'},
  description: `Creates a ${Graph.docType(
    'typedDict'
  )} from a variable number of arguments`,
  argDescriptions: {
    manyX: `The values to add to the ${Graph.docType(
      'typedDict'
    )}: Note: in Weave, the arguments are {[key:string]: value}`,
  },
  returnValueDescription: `The ${Graph.docType('typedDict')}`,
  renderInfo: {
    type: 'dictionaryLiteral',
  },
  returnType: inputs => {
    // const argValues = Object.values(inputs);
    return Types.typedDict(_.mapValues(inputs, n => n.type) as any);
  },
  resolver: inputs => {
    return inputs;
  },
});
